import {ModalModule} from 'ng-design-system';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClassificationsTemplateComponent} from './classifications-template.component';
import {DcpMediaModule} from '../../../shared/dcp-media/dcp-media.module';
import {MediaModule} from '@spartacus/storefront';
import {PlansAndPricingDataService} from '../plans-and-pricing/plans-and-pricing-data.service';
import {I18nModule, TranslatePipe} from '@spartacus/core';
import {BrowserModule, Meta} from '@angular/platform-browser';

@NgModule({
  declarations: [
    ClassificationsTemplateComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    DcpMediaModule,
    MediaModule,
    I18nModule,
    ModalModule,
  ],
  providers: [
    Meta,
    PlansAndPricingDataService,
    TranslatePipe,
  ],
  exports: [
    ClassificationsTemplateComponent,
  ]
})
export class ClassificationsTemplateModule {
}
